import React, { Component } from "react";

class MobileSubscription extends Component {
  render() {
    const { purchasedPlan, userData, history } = this.props;
    const {
      isSubscriptionTrial,
      relevantSubscriptionDate,
    } = userData;

    const { planTitle = "NYA FREE" } = purchasedPlan;

    const displayPlan = planTitle.toUpperCase();

    return (
      <div id="account-menu-container">
        <div className="one column row links subscription-overview">
          <div className="left aligned column">
            <h2>{displayPlan}</h2>
          </div>
          {isSubscriptionTrial ? (
            <div className="free-trial-badge">FREE TRIAL</div>
          ) : null}
        </div>
        <div className="one column row links overview-btn">
          <div className="center aligned column">
            {isSubscriptionTrial ? (
              <div>
                <div className="plan-info">
                  Your plan will expire on: <b>{relevantSubscriptionDate}</b>
                </div>
                <div className="plan-info description">
                  If you wish to continue with your subscription after the trial
                  ends, you will need to add a payment method.
                </div>
              </div>
            ) : null}
            <button
              className="ui fluid primary button overview"
              onClick={() => history.push("/account?screen=plans")}
            >
              CHANGE PLAN
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default MobileSubscription;
